import axios from '@/axios-api';
import Pathes from '@/helpers/pathes';

export const loyaltyService = {
  status: () => axios.get(Pathes.Loyalty.status),
  levels: () => axios.get(Pathes.Loyalty.levels),
  reserve: payload => axios.post(Pathes.Loyalty.reserve, payload),
  reservationLimits: () => axios.get(Pathes.Loyalty.reservationLimits),
};
